import { Navigate, Outlet } from 'react-router-dom';
import { useIsSandbox } from '../store/auth';

/**
 * Blocks the account/settings area for the self-serve sandbox demo. A sandbox
 * user who navigates straight to /settings, /members, /billing, or /profile is
 * bounced to the dashboard — matching the hidden nav, and backing up the
 * server-side sandbox write lockdown so the demo can't manage the account.
 */
export function SandboxRestrictedGate() {
  const isSandbox = useIsSandbox();
  if (isSandbox) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
